import * as Types from '@saas/interfaces/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreatePatientActionHistoryMutationVariables = Types.Exact<{
  patientId: Types.Scalars['String']['input'];
  actionType: Types.Actiontype;
  isTechnical: Types.Scalars['Boolean']['input'];
  updatedById: Types.Scalars['String']['input'];
  actionInsiDetails: Types.PatientActionHistoryActionInsiDetailsInput;
}>;


export type CreatePatientActionHistoryMutation = (
  { __typename?: 'Mutation' }
  & { patientMutationAddPatientActionHistory?: Types.Maybe<(
    { __typename?: 'PatientActionHistory' }
    & Pick<Types.PatientActionHistory, 'id' | 'objectId' | 'updatedByLabel' | 'actionDate' | 'actionType' | 'isTechnical'>
    & { actionInsiDetails?: Types.Maybe<(
      { __typename?: 'PatientActionHistoryActionInsiDetails' }
      & Pick<Types.PatientActionHistoryActionInsiDetails, 'callType' | 'returnType' | 'insNum' | 'oid' | 'identityTraits' | 'insHistory'>
    )> }
  )> }
);


export const CreatePatientActionHistoryDocument = gql`
    mutation createPatientActionHistory($patientId: String!, $actionType: ACTIONTYPE!, $isTechnical: Boolean!, $updatedById: String!, $actionInsiDetails: PatientActionHistoryActionInsiDetailsInput!) {
  patientMutationAddPatientActionHistory(
    patientId: $patientId
    actionType: $actionType
    isTechnical: $isTechnical
    updatedById: $updatedById
    actionInsiDetails: $actionInsiDetails
  ) {
    id
    objectId
    updatedByLabel
    actionDate
    actionType
    isTechnical
    actionInsiDetails {
      callType
      returnType
      insNum
      oid
      identityTraits
      insHistory
    }
  }
}
    `;
export type CreatePatientActionHistoryMutationFn = Apollo.MutationFunction<CreatePatientActionHistoryMutation, CreatePatientActionHistoryMutationVariables>;

/**
 * __useCreatePatientActionHistoryMutation__
 *
 * To run a mutation, you first call `useCreatePatientActionHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientActionHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientActionHistoryMutation, { data, loading, error }] = useCreatePatientActionHistoryMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      actionType: // value for 'actionType'
 *      isTechnical: // value for 'isTechnical'
 *      updatedById: // value for 'updatedById'
 *      actionInsiDetails: // value for 'actionInsiDetails'
 *   },
 * });
 */
export function useCreatePatientActionHistoryMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientActionHistoryMutation, CreatePatientActionHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientActionHistoryMutation, CreatePatientActionHistoryMutationVariables>(CreatePatientActionHistoryDocument, options);
      }
export type CreatePatientActionHistoryMutationHookResult = ReturnType<typeof useCreatePatientActionHistoryMutation>;
export type CreatePatientActionHistoryMutationResult = Apollo.MutationResult<CreatePatientActionHistoryMutation>;
export type CreatePatientActionHistoryMutationOptions = Apollo.BaseMutationOptions<CreatePatientActionHistoryMutation, CreatePatientActionHistoryMutationVariables>;